import Cookies from 'js-cookie'
import Login from '../components/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import { createRouter, createWebHashHistory } from 'vue-router'



import MaterialGallery from '../views/material/Gallery.vue'
import MaterialVideoSc from '../views/material/VideoSc.vue'

// AI小说
import WordDashboard from '../views/novel/WordDashboard.vue'
import NovelList from '../views/novel/NovelList.vue'
import NovelStudio from '../views/novel/NovelStudio.vue'
import WordReport from '../views/novel/WordReport.vue'
import StudioPipeline from '../views/novel/StudioPipeline.vue'

// 系统配置
import SystemPublish from '../views/system/Publish.vue'
import SystemOssConfig from '../views/system/OssConfig.vue'
import SystemAIConfig from '../views/system/SystemAIConfig.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [


      // —— AI小说（保持原有路由，不影响现有页面）——
      {
        path: 'novel',
        children: [
          {
            path: 'worddashboard',
            name: 'WordDashboard',
            component: WordDashboard
          },
          {
            path: 'novellist',
            name: 'NovelList',
            component: NovelList
          },
          {
            path: 'studiopipeline',
            name: 'StudioPipeline',
            component: StudioPipeline
          },
          {
            path: 'novelstudio',
            name: 'NovelStudio',
            component: NovelStudio
          },
          {
            path: 'wordreport',
            name: 'WordReport',
            component: WordReport
          }
        ]
      },

      // 素材管理
      {
        path: 'material',
        children: [
          {
            path: 'gallery',
            name: 'MaterialGallery',
            component: MaterialGallery
          },
          {
            path: 'video-sc',
            name: 'MaterialVideoSc',
            component: MaterialVideoSc
          }
        ]
      },

      // 系统配置
      {
        path: 'system',
        children: [
          {
            path: 'OssConfig',
            name: 'SystemOssConfig',
            component: SystemOssConfig
          },
          {
            path: 'systemaiconfig',
            name: 'SystemAIConfig',
            component: SystemAIConfig
          },
          {
            path: 'publish',
            name: 'SystemPublish',
            component: SystemPublish
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory('/shop/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isLoginPage = to.path === '/login'

  if (requiresAuth) {
    if (isAuthenticated) {
      if (to.path === '/') {
        next('/novel/worddashboard')
        return
      }
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else if (isLoginPage) {
    if (isAuthenticated) {
      next('/novel/worddashboard')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
